// StationPanelLinePhoto – řádkový výpis s detailem: thumbnail size=s, vše z StationPanelSmall + region, district, orp, note (zkrácený)
import { useNavigate } from 'react-router-dom'
import { Button, Chip } from '@heroui/react'
import { StationPhoto } from '../StationPhoto'

function getDistinctObsTypes(station) {
  if (!station.observation) return []
  return [...new Set(station.observation.map(o => o.obs_type))]
}

export function StationPanelLinePhoto({ station, onDetailClick }) {
  const navigate = useNavigate()

  const handleDetail = () => {
    if (onDetailClick) onDetailClick(station)
    else navigate(`/station/${station.gh_id}`)
  }

  const obsTypes = getDistinctObsTypes(station)

  return (
    <div className="flex items-stretch gap-3 p-3 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 transition-colors">
      {/* Thumbnail */}
      <StationPhoto
        ghId={station.gh_id}
        size="s"
        className="w-[100px] h-[100px] shrink-0 rounded-lg"
        alt={station.name}
      />

      {/* Main info */}
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-mono text-gray-400">{station.gh_id}</span>
          {station.wsi && <span className="text-xs font-mono text-gray-400">{station.wsi}</span>}
          <span className="text-xs bg-gray-100 px-1.5 rounded text-gray-600">{station.station_type}</span>
          {obsTypes.map(t => (
            <Chip key={t} size="sm" variant="flat" className="text-xs h-4 px-1">{t}</Chip>
          ))}
        </div>
        <span className="font-medium text-sm truncate">{station.full_name || station.name}</span>
        <div className="text-xs text-gray-500 flex flex-wrap gap-x-3 gap-y-0.5">
          <span>{station.latitude?.toFixed(4)}°N {station.longitude?.toFixed(4)}°E</span>
          {station.elevation != null && <span>{station.elevation} m n.m.</span>}
        </div>
        {(station.h2 || station.h3 || station.h4) && (
          <div className="text-xs text-gray-400 flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
            {station.h2 && <span>Kraj: {station.h2}</span>}
            {station.h3 && <span>Okres: {station.h3}</span>}
            {station.h4 && <span>ORP: {station.h4}</span>}
          </div>
        )}
      </div>

      {/* Action */}
      <div className="flex items-center shrink-0">
        <Button size="sm" variant="secondary" onPress={handleDetail}>Detail</Button>
      </div>
    </div>
  )
}